import { render, staticRenderFns } from "./liveDetailsl.vue?vue&type=template&id=10f00ae3&"
import script from "./liveDetailsl.vue?vue&type=script&lang=js&"
export * from "./liveDetailsl.vue?vue&type=script&lang=js&"
import style0 from "./liveDetailsl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports